import { Component, ViewChild, AfterViewInit, EventEmitter, HostListener } from '@angular/core';
import { CrawfordDialogComponent } from 'crawford-shell';
import { UserService } from '../../user/user.service';
import { Observable } from 'rxjs/Observable';
import { timer } from 'rxjs/observable/timer';
import { Subscription } from 'rxjs/Subscription';
import * as moment from 'moment';

@Component({
  selector: 'app-session-expiry',
  templateUrl: './session-expiry.component.html'
})
export class SessionExpiryComponent implements AfterViewInit {

  @ViewChild('sessionDialog') sessionDialog: CrawfordDialogComponent;

  public countdownDisplay: EventEmitter<string> = new EventEmitter<string>();
  private countdownTimerSubscription: Subscription;
  private intervalTimer: Observable<number>;
  private intervalTimerSubscription: Subscription;
  private dialogVisible: boolean;
  private expiry: number;
  private formsSessionWarnSecs: number;
  private lastSessionCheck: moment.Moment;

  ngAfterViewInit(): void {
    this.subscribeToUserDetails();
  }

  constructor(private userService: UserService) { }

  private formatCountdown(totalSecsRemaining: number) {
    const minsPartRemaining = Math.floor(totalSecsRemaining / 60);
    const secsPartRemaining = totalSecsRemaining % 60;
    return `${minsPartRemaining} minutes and ${secsPartRemaining} seconds`;
  }

  private initCountdownTimer(): Observable<number> {
    return timer(0, 1000)
      .map(secTick => this.expiry - secTick);
  }

  private initIntervalTimer(): Observable<number> {
    const intervalSecs = 10;
    const intervalMSecs = intervalSecs * 1000;
    return timer(0, intervalMSecs)
      .filter(intervalTick => intervalTick === 0 || this.expiry >= this.formsSessionWarnSecs)
      .map(intervalTick => this.expiry -= intervalSecs);
  }

  public renewSession(): void {
    this.userService.renewSession().subscribe(
      response => this.userService.refreshUserDetails(),
      error => window.location.reload()
    );
  }

  private restartTimers(): void {
    this.unsubscribeExistingTimers();
    this.intervalTimer = this.initIntervalTimer();

    this.intervalTimerSubscription = this.intervalTimer.subscribe(intervalTick => {
      if (this.shouldShowCountdown(intervalTick) && this.countdownNotVisible()) {
        this.countdownTimerSubscription = this.initCountdownTimer()
          .subscribe(countdown => {
            if (countdown <= 0) {
              this.logout();
            } else {
              this.countdownDisplay.next(this.formatCountdown(countdown));
            }
          });
        this.sessionDialog.showDialog();
      }
    });
  }

  private shouldShowCountdown(intervalTick: number) {
    const intervalPastWarning = intervalTick <= this.formsSessionWarnSecs;
    const expiryPastWarning = this.expiry <= this.formsSessionWarnSecs;
    return expiryPastWarning || intervalPastWarning;
  }

  private countdownNotVisible() {
    return !this.sessionDialog.isVisible;
  }

  private logout() {
    this.userService.logout()
      .subscribe(success => { }, error => window.location.reload());
  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
    const now = moment();
    if (this.idleBrowserDetected(now)) {
      console.log('idle browser detected');
      this.subscribeToUserDetails();
    }
  }

  private idleBrowserDetected(now: moment.Moment) {
    return this.lastSessionCheck &&
           this.countdownNotVisible() &&
           this.lastSessionCheck
              .add(this.expiry, 's')
              .subtract(this.formsSessionWarnSecs)
              .isBefore(now);
  }

  private subscribeToUserDetails(): void {
    this.userService.subscribeToUserDetails().subscribe(
      user => {
        if (user.userType === 'External') {
          this.lastSessionCheck = moment();
          this.expiry = user.authTokenExpiration;
          this.formsSessionWarnSecs = user.formsSessionWarnSecs;
          this.restartTimers();
        }
      });
  }

  private unsubscribeExistingTimers() {
    if (this.intervalTimerSubscription) {
      this.intervalTimerSubscription.unsubscribe();
    }
    if (this.countdownTimerSubscription) {
      this.countdownTimerSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/session/session-expiry/session-expiry.component.ts